export const Knowledge = (props) => {
  const width = (props.size * 25) / 24 || 25;
  const height = props.size || 24;
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M17 4V2M12 4V2M7 4V2M7 20V22M12 20V22M17 20V22M20 17H22M20 12H22M20 7H22M4 17H2M4 12H2M4 7H2M8 8.6V15.4C8 15.7314 8.26863 16 8.6 16H15.4C15.7314 16 16 15.7314 16 15.4V8.6C16 8.26863 15.7314 8 15.4 8H8.6C8.26863 8 8 8.26863 8 8.6ZM20 19.4V4.6C20 4.26863 19.7314 4 19.4 4H4.6C4.26863 4 4 4.26863 4 4.6V19.4C4 19.7314 4.26863 20 4.6 20H19.4C19.7314 20 20 19.7314 20 19.4Z" stroke={props.color || 'currentColor'} strokeWidth="1.5" strokeLinecap="round"  />
    </svg>
  );
};
